import { z } from 'zod'

/** Matches an already-decoded unbounded-union value: a real number, `Infinity` included. */
export const decodedUnboundedValueSchema = z.custom<number>((value) => typeof value === 'number')
